var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("filter", {
  id: "filter0_bi_1426_1482",
  x: -256.992,
  y: 388.492,
  width: 345.648,
  height: 327.892,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  in: "BackgroundImageFix",
  stdDeviation: 16.313
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "SourceAlpha",
  operator: "in",
  result: "effect1_backgroundBlur_1426_1482"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect1_backgroundBlur_1426_1482",
  result: "shape"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 48.939
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 24.4695
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "arithmetic",
  k2: -1,
  k3: 1
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.05 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "shape",
  result: "effect2_innerShadow_1426_1482"
}));

var _ref3 = /*#__PURE__*/React.createElement("pattern", {
  id: "pattern0_1426_1482",
  patternContentUnits: "objectBoundingBox",
  width: 0.662857,
  height: 0.503311
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#image0_1426_1482",
  transform: "scale(0.00571429 0.00662252)"
}));

var _ref4 = /*#__PURE__*/React.createElement("filter", {
  id: "filter1_b_1426_1482",
  x: -23.7151,
  y: 525.521,
  width: 345.648,
  height: 311.579,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  in: "BackgroundImageFix",
  stdDeviation: 16.313
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "SourceAlpha",
  operator: "in",
  result: "effect1_backgroundBlur_1426_1482"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect1_backgroundBlur_1426_1482",
  result: "shape"
}));

var _ref5 = /*#__PURE__*/React.createElement("pattern", {
  id: "pattern1_1426_1482",
  patternContentUnits: "objectBoundingBox",
  width: 0.662857,
  height: 0.503311
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#image0_1426_1482",
  transform: "scale(0.00571429 0.00662252)"
}));

var _ref6 = /*#__PURE__*/React.createElement("filter", {
  id: "filter2_b_1426_1482",
  x: -253.73,
  y: 122.589,
  width: 345.648,
  height: 311.579,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  in: "BackgroundImageFix",
  stdDeviation: 16.313
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "SourceAlpha",
  operator: "in",
  result: "effect1_backgroundBlur_1426_1482"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect1_backgroundBlur_1426_1482",
  result: "shape"
}));

var _ref7 = /*#__PURE__*/React.createElement("filter", {
  id: "filter3_bi_1426_1482",
  x: -22.0833,
  y: 259.619,
  width: 345.648,
  height: 327.892,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  in: "BackgroundImageFix",
  stdDeviation: 16.313
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "SourceAlpha",
  operator: "in",
  result: "effect1_backgroundBlur_1426_1482"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect1_backgroundBlur_1426_1482",
  result: "shape"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 48.939
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 24.4695
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "arithmetic",
  k2: -1,
  k3: 1
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.05 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "shape",
  result: "effect2_innerShadow_1426_1482"
}));

var _ref8 = /*#__PURE__*/React.createElement("pattern", {
  id: "pattern2_1426_1482",
  patternContentUnits: "objectBoundingBox",
  width: 0.662857,
  height: 0.503311
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#image0_1426_1482",
  transform: "scale(0.00571429 0.00662252)"
}));

var _ref9 = /*#__PURE__*/React.createElement("filter", {
  id: "filter4_bi_1426_1482",
  x: 227.506,
  y: 408.067,
  width: 316.284,
  height: 282.215,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  in: "BackgroundImageFix",
  stdDeviation: 8.15651
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "SourceAlpha",
  operator: "in",
  result: "effect1_backgroundBlur_1426_1482"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect1_backgroundBlur_1426_1482",
  result: "shape"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: -16.313
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 48.939
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "arithmetic",
  k2: -1,
  k3: 1
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.505176 0 0 0 0 0.643727 0 0 0 0 1 0 0 0 0.5 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "shape",
  result: "effect2_innerShadow_1426_1482"
}));

var _ref10 = /*#__PURE__*/React.createElement("pattern", {
  id: "pattern3_1426_1482",
  patternContentUnits: "objectBoundingBox",
  width: 0.662857,
  height: 0.503311
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#image0_1426_1482",
  transform: "scale(0.00571429 0.00662252)"
}));

var _ref11 = /*#__PURE__*/React.createElement("filter", {
  id: "filter5_bi_1426_1482",
  x: 452.625,
  y: 262.881,
  width: 345.648,
  height: 327.892,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  in: "BackgroundImageFix",
  stdDeviation: 16.313
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "SourceAlpha",
  operator: "in",
  result: "effect1_backgroundBlur_1426_1482"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect1_backgroundBlur_1426_1482",
  result: "shape"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 48.939
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 24.4695
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "arithmetic",
  k2: -1,
  k3: 1
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.05 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "shape",
  result: "effect2_innerShadow_1426_1482"
}));

var _ref12 = /*#__PURE__*/React.createElement("pattern", {
  id: "pattern4_1426_1482",
  patternContentUnits: "objectBoundingBox",
  width: 0.662857,
  height: 0.503311
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#image0_1426_1482",
  transform: "scale(0.00571429 0.00662252)"
}));

var _ref13 = /*#__PURE__*/React.createElement("filter", {
  id: "filter6_bi_1426_1482",
  x: 217.718,
  y: 122.589,
  width: 345.648,
  height: 327.892,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  in: "BackgroundImageFix",
  stdDeviation: 16.313
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "SourceAlpha",
  operator: "in",
  result: "effect1_backgroundBlur_1426_1482"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect1_backgroundBlur_1426_1482",
  result: "shape"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 48.939
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 24.4695
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "arithmetic",
  k2: -1,
  k3: 1
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.05 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "shape",
  result: "effect2_innerShadow_1426_1482"
}));

var _ref14 = /*#__PURE__*/React.createElement("pattern", {
  id: "pattern5_1426_1482",
  patternContentUnits: "objectBoundingBox",
  width: 0.662857,
  height: 0.503311
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#image0_1426_1482",
  transform: "scale(0.00571429 0.00662252)"
}));

var _ref26 = /*#__PURE__*/React.createElement("image", {
  id: "image0_1426_1482",
  width: 116,
  height: 76,
  xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAHQAAABMCAYAAAC8s5PnAAAACXBIWXMAAALFAAACxQGJ1n/vAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAMJSURBVHgB7d27btRQEIdxUwAF9w4koOBScKm4Cop0XMQKRAMKDREIKlIlgg6kIKUgBbSkCA8AFbTU5BV4HON+fyuNtBuvRf5f+UmWj8eFR2dmjptmCtq23QN3BO4k3AW4a3ALcHfgRnAPi25UvMdCcc16NsVAsRqLaQghhBAGTvcBPwinj/8luFtwSkQewy3CPYd7CfeieO1icS1as57tMpxidagJIYQQwnDpPtb74Y7DaZdEScJ9uCdwSmLewK3AvSu6leI9lGQ9hdOzKQaK1Qm4sdiHEEIIYU50H+ajcGfhrsNpN0UJ0Cu4Vbj3cOtwn4puvXiP1eKalSjdhVPpTTE91oQQQgihf7qP8D447QqpJKS+G5WdtOuiHZs1uC9wX+G+Fd0m3Ge4j01tzXo2xUCxUqlRsd/bhBBCCGFn6T64B+BOw12F047IMziVp7Q7o+RkC+473K+i07VKnpSMfYBbhlOPkmJ1BU6xH3tHIYQQQpgxE6aizsDdhNMk1xKcSlEqY2kHSEnMb7g/RadrfxTXojVr90gxUKwUU5XUxt5RCCGEEGbMhP6h83BqHn4Ep3KSGp7V76NdIe32bMP9Lbrt4j22imvWsykGOh7gNtw5uLF3FEIIIYQZM2VSpA+9EoK3cBtwKmMpYdEOUDUp0rU/i2vRmpUUaYpOsVJMFfskRSGEEMJOM6F8phJOtXymc4BUYqqWz1Ta6qN8tllcs55NMVCsbsClfBZCCCHMg7beaK2mYI3fT9NoreZm7dgoiemj0Vpr1rOp0VqxSqN1CCGEMBRajHu3PlRQ4+PVkXyVk6oj+ZpI62Mkf6245mlG8nXMQUbyQwghhKHQ4gDBCWUdHUio0XMd3vgaTkmHxuCrhzduFK/t4/BGHXSpKb/0D4UQQghDoZ39bz7uwSlR0q5LH7/5WC6uJb/5CCGEEHY77fx+CKseJTUyq0SnxGapeA+tRTtAejbFID+EDSGEEP5Xuo/6YbhTcNolUelNfTdKnh7A6cwkjcGPivfQWlQCuwinGMx8guwf/mQ/iMmMnBkAAAAASUVORK5CYII="
});

function SvgSignupHeroFigure(_ref, svgRef) {
  var _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25;

  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 696,
    height: 912,
    viewBox: "0 0 696 912",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_bi_1426_1482)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M53.8318 536.102C56.7631 541.161 56.7632 547.401 53.8318 552.46L-8.08472 659.31C-11.0021 664.345 -16.3804 667.444 -22.1992 667.444H-146.136C-151.955 667.444 -157.333 664.345 -160.251 659.31L-222.167 552.46C-225.098 547.401 -225.098 541.161 -222.167 536.102L-160.251 429.252C-157.333 424.217 -151.955 421.118 -146.136 421.118H-22.1992C-16.3804 421.118 -11.0021 424.217 -8.08473 429.252L53.8318 536.102Z",
    fill: "white",
    fillOpacity: 0.04,
    style: {
      fill: "white",
      fillOpacity: 0.04
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.8318 536.102C56.7631 541.161 56.7632 547.401 53.8318 552.46L-8.08472 659.31C-11.0021 664.345 -16.3804 667.444 -22.1992 667.444H-146.136C-151.955 667.444 -157.333 664.345 -160.251 659.31L-222.167 552.46C-225.098 547.401 -225.098 541.161 -222.167 536.102L-160.251 429.252C-157.333 424.217 -151.955 421.118 -146.136 421.118H-22.1992C-16.3804 421.118 -11.0021 424.217 -8.08473 429.252L53.8318 536.102Z",
    fill: "url(#pattern0_1426_1482)",
    fillOpacity: 0.2,
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.1261 536.511C55.9108 541.317 55.9109 547.245 53.1261 552.051L-8.79044 658.901C-11.562 663.684 -16.6714 666.629 -22.1992 666.629H-146.136C-151.664 666.629 -156.773 663.684 -159.545 658.901L-221.461 552.051C-224.246 547.245 -224.246 541.317 -221.461 536.511L-159.545 429.661C-156.773 424.878 -151.664 421.933 -146.136 421.933H-22.1992C-16.6714 421.933 -11.562 424.878 -8.79045 429.661L53.1261 536.511Z",
    stroke: "url(#paint0_linear_1426_1482)",
    style: {},
    strokeWidth: 1.6313
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_b_1426_1482)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M287.108 673.131C290.039 678.19 290.04 684.43 287.108 689.489L225.192 796.339C222.274 801.374 216.896 804.473 211.077 804.473H87.1404C81.3216 804.473 75.9433 801.374 73.0259 796.339L11.1093 689.489C8.178 684.43 8.17799 678.19 11.1093 673.131L73.0258 566.281C75.9433 561.246 81.3215 558.147 87.1404 558.147H211.077C216.896 558.147 222.274 561.246 225.192 566.281L287.108 673.131Z",
    fill: "url(#pattern1_1426_1482)",
    fillOpacity: 0.2,
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.402 673.54C289.187 678.346 289.187 684.274 286.402 689.08L224.486 795.93C221.714 800.713 216.605 803.657 211.077 803.657H87.1404C81.6125 803.657 76.5031 800.713 73.7316 795.93L11.8151 689.08C9.03029 684.274 9.03028 678.346 11.815 673.54L73.7316 566.69C76.5031 561.907 81.6125 558.962 87.1404 558.962H211.077C216.605 558.962 221.714 561.907 224.486 566.69L286.402 673.54Z",
    stroke: "url(#paint1_linear_1426_1482)",
    style: {},
    strokeWidth: 1.6313
  })), /*#__PURE__*/React.createElement("path", {
    d: "M522.941 807.307C525.725 812.113 525.725 818.041 522.941 822.847L461.024 929.697C458.252 934.48 453.143 937.425 447.615 937.425H323.678C318.151 937.425 313.041 934.48 310.27 929.697L248.353 822.847C245.568 818.041 245.568 812.113 248.353 807.307L310.27 700.457C313.041 695.674 318.151 692.729 323.678 692.729H447.615C453.143 692.729 458.252 695.674 461.024 700.457L522.941 807.307Z",
    stroke: "url(#paint2_linear_1426_1482)",
    style: {},
    strokeWidth: 1.6313
  }), /*#__PURE__*/React.createElement("path", {
    d: "M761.111 678.434C763.896 683.24 763.896 689.168 761.111 693.974L699.195 800.824C696.423 805.607 691.314 808.552 685.786 808.552H561.849C556.321 808.552 551.212 805.607 548.44 800.824L486.524 693.974C483.739 689.168 483.739 683.24 486.524 678.434L548.44 571.584C551.212 566.801 556.321 563.856 561.849 563.856H685.786C691.314 563.856 696.423 566.801 699.195 571.584L761.111 678.434Z",
    stroke: "url(#paint3_linear_1426_1482)",
    style: {},
    strokeWidth: 1.6313
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_b_1426_1482)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M57.0935 270.2C60.0248 275.258 60.0249 281.499 57.0935 286.557L-4.823 393.408C-7.74042 398.442 -13.1187 401.542 -18.9375 401.542H-142.874C-148.693 401.542 -154.071 398.442 -156.989 393.408L-218.905 286.558C-221.837 281.499 -221.837 275.258 -218.905 270.2L-156.989 163.349C-154.071 158.315 -148.693 155.215 -142.874 155.215H-18.9375C-13.1187 155.215 -7.74042 158.315 -4.82301 163.349L57.0935 270.2Z",
    fill: "white",
    fillOpacity: 0.01,
    style: {
      fill: "white",
      fillOpacity: 0.01
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.3878 270.609C59.1725 275.414 59.1726 281.343 56.3878 286.149L-5.52872 392.999C-8.30028 397.782 -13.4096 400.726 -18.9375 400.726H-142.874C-148.402 400.726 -153.512 397.782 -156.283 392.999L-218.2 286.149C-220.984 281.343 -220.984 275.414 -218.2 270.609L-156.283 163.758C-153.512 158.975 -148.402 156.031 -142.874 156.031H-18.9375C-13.4097 156.031 -8.30028 158.975 -5.52873 163.758L56.3878 270.609Z",
    stroke: "url(#paint4_linear_1426_1482)",
    style: {},
    strokeWidth: 1.6313
  })), /*#__PURE__*/React.createElement("path", {
    d: "M289.665 136.841C292.45 141.647 292.45 147.576 289.665 152.381L227.749 259.232C224.977 264.015 219.868 266.959 214.34 266.959H90.4031C84.8752 266.959 79.7658 264.015 76.9943 259.232L15.0778 152.381C12.293 147.576 12.293 141.647 15.0777 136.841L76.9943 29.9912C79.7658 25.2083 84.8752 22.2638 90.4031 22.2638H214.34C219.868 22.2638 224.977 25.2083 227.749 29.9912L289.665 136.841Z",
    stroke: "url(#paint5_linear_1426_1482)",
    style: {},
    strokeWidth: 1.6313
  }), /*#__PURE__*/React.createElement("path", {
    d: "M522.941 3.0752C525.725 7.88091 525.725 13.8095 522.941 18.6152L461.024 125.465C458.252 130.248 453.143 133.193 447.615 133.193H323.678C318.151 133.193 313.041 130.248 310.27 125.465L248.353 18.6152C245.568 13.8095 245.568 7.88094 248.353 3.07521L310.27 -103.775C313.041 -108.558 318.151 -111.502 323.678 -111.502H447.615C453.143 -111.502 458.252 -108.558 461.024 -103.775L522.941 3.0752Z",
    stroke: "url(#paint6_linear_1426_1482)",
    style: {},
    strokeWidth: 1.6313
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_bi_1426_1482)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M288.74 407.229C291.671 412.288 291.671 418.528 288.74 423.587L226.823 530.437C223.906 535.472 218.528 538.571 212.709 538.571H88.7722C82.9534 538.571 77.5751 535.472 74.6577 530.437L12.7412 423.587C9.80983 418.529 9.80982 412.288 12.7412 407.229L74.6577 300.379C77.5751 295.344 82.9534 292.245 88.7722 292.245H212.709C218.528 292.245 223.906 295.344 226.823 300.379L288.74 407.229Z",
    fill: "white",
    fillOpacity: 0.04,
    style: {
      fill: "white",
      fillOpacity: 0.04
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.74 407.229C291.671 412.288 291.671 418.528 288.74 423.587L226.823 530.437C223.906 535.472 218.528 538.571 212.709 538.571H88.7722C82.9534 538.571 77.5751 535.472 74.6577 530.437L12.7412 423.587C9.80983 418.529 9.80982 412.288 12.7412 407.229L74.6577 300.379C77.5751 295.344 82.9534 292.245 88.7722 292.245H212.709C218.528 292.245 223.906 295.344 226.823 300.379L288.74 407.229Z",
    fill: "url(#pattern2_1426_1482)",
    fillOpacity: 0.2,
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.034 407.638C290.819 412.444 290.819 418.372 288.034 423.178L226.118 530.028C223.346 534.811 218.237 537.756 212.709 537.756H88.7722C83.2443 537.756 78.135 534.811 75.3634 530.028L13.4469 423.178C10.6621 418.372 10.6621 412.444 13.4469 407.638L75.3634 300.788C78.1349 296.005 83.2443 293.061 88.7722 293.061H212.709C218.237 293.061 223.346 296.005 226.118 300.788L288.034 407.638Z",
    stroke: "url(#paint7_linear_1426_1482)",
    style: {},
    strokeWidth: 1.6313
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_bi_1426_1482)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M523.647 540.996C526.579 546.054 526.579 552.295 523.647 557.353L461.731 664.204C458.813 669.238 453.435 672.338 447.616 672.338H323.679C317.861 672.338 312.482 669.238 309.565 664.204L247.648 557.353C244.717 552.295 244.717 546.054 247.648 540.996L309.565 434.145C312.482 429.111 317.861 426.011 323.679 426.011H447.616C453.435 426.011 458.813 429.111 461.731 434.145L523.647 540.996Z",
    fill: "url(#paint8_radial_1426_1482)",
    fillOpacity: 0.5,
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M523.647 540.996C526.579 546.054 526.579 552.295 523.647 557.353L461.731 664.204C458.813 669.238 453.435 672.338 447.616 672.338H323.679C317.861 672.338 312.482 669.238 309.565 664.204L247.648 557.353C244.717 552.295 244.717 546.054 247.648 540.996L309.565 434.145C312.482 429.111 317.861 426.011 323.679 426.011H447.616C453.435 426.011 458.813 429.111 461.731 434.145L523.647 540.996Z",
    fill: "url(#pattern3_1426_1482)",
    fillOpacity: 0.2,
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M524.353 557.762C527.431 552.451 527.431 545.898 524.353 540.587L462.436 433.736C459.373 428.45 453.726 425.196 447.616 425.196H323.679C317.57 425.196 311.922 428.45 308.859 433.736L246.943 540.587C243.865 545.898 243.865 552.451 246.943 557.762L308.859 664.613C311.922 669.899 317.57 673.153 323.679 673.153H447.616C453.726 673.153 459.373 669.899 462.436 664.613L524.353 557.762Z",
    stroke: "url(#paint9_angular_1426_1482)",
    strokeOpacity: 0.6,
    style: {},
    strokeWidth: 1.6313
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M384.667 626.334C427.929 626.334 463 591.263 463 548C463 504.738 427.929 469.667 384.667 469.667C341.404 469.667 306.333 504.738 306.333 548C306.333 591.263 341.404 626.334 384.667 626.334ZM409.104 506.158C410.294 501.933 406.193 499.434 402.449 502.102L350.173 539.343C346.112 542.236 346.751 548 351.133 548H364.898V547.894H391.727L369.867 555.607L360.23 589.843C359.04 594.068 363.14 596.566 366.885 593.898L419.161 556.658C423.222 553.765 422.583 548 418.201 548H397.326L409.104 506.158Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_bi_1426_1482)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M763.448 410.492C766.38 415.55 766.38 421.791 763.448 426.85L701.532 533.7C698.614 538.734 693.236 541.834 687.417 541.834H563.48C557.662 541.834 552.283 538.735 549.366 533.7L487.449 426.85C484.518 421.791 484.518 415.55 487.449 410.492L549.366 303.642C552.283 298.607 557.662 295.507 563.48 295.507H687.417C693.236 295.507 698.614 298.607 701.532 303.642L763.448 410.492Z",
    fill: "white",
    fillOpacity: 0.04,
    style: {
      fill: "white",
      fillOpacity: 0.04
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M763.448 410.492C766.38 415.55 766.38 421.791 763.448 426.85L701.532 533.7C698.614 538.734 693.236 541.834 687.417 541.834H563.48C557.662 541.834 552.283 538.735 549.366 533.7L487.449 426.85C484.518 421.791 484.518 415.55 487.449 410.492L549.366 303.642C552.283 298.607 557.662 295.507 563.48 295.507H687.417C693.236 295.507 698.614 298.607 701.532 303.642L763.448 410.492Z",
    fill: "url(#pattern4_1426_1482)",
    fillOpacity: 0.2,
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M762.743 410.901C765.527 415.706 765.527 421.635 762.743 426.441L700.826 533.291C698.054 538.074 692.945 541.018 687.417 541.018H563.48C557.953 541.018 552.843 538.074 550.072 533.291L488.155 426.441C485.37 421.635 485.37 415.706 488.155 410.901L550.072 304.05C552.843 299.268 557.953 296.323 563.48 296.323H687.417C692.945 296.323 698.054 299.268 700.826 304.05L762.743 410.901Z",
    stroke: "url(#paint10_linear_1426_1482)",
    style: {},
    strokeWidth: 1.6313
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_bi_1426_1482)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M528.541 270.2C531.473 275.258 531.473 281.499 528.541 286.557L466.625 393.408C463.707 398.442 458.329 401.542 452.51 401.542H328.573C322.755 401.542 317.376 398.442 314.459 393.408L252.542 286.558C249.611 281.499 249.611 275.258 252.542 270.2L314.459 163.349C317.376 158.315 322.755 155.215 328.573 155.215H452.51C458.329 155.215 463.707 158.315 466.625 163.349L528.541 270.2Z",
    fill: "white",
    fillOpacity: 0.04,
    style: {
      fill: "white",
      fillOpacity: 0.04
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M528.541 270.2C531.473 275.258 531.473 281.499 528.541 286.557L466.625 393.408C463.707 398.442 458.329 401.542 452.51 401.542H328.573C322.755 401.542 317.376 398.442 314.459 393.408L252.542 286.558C249.611 281.499 249.611 275.258 252.542 270.2L314.459 163.349C317.376 158.315 322.755 155.215 328.573 155.215H452.51C458.329 155.215 463.707 158.315 466.625 163.349L528.541 270.2Z",
    fill: "url(#pattern5_1426_1482)",
    fillOpacity: 0.2,
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M527.836 270.609C530.62 275.414 530.62 281.343 527.836 286.149L465.919 392.999C463.147 397.782 458.038 400.726 452.51 400.726H328.573C323.046 400.726 317.936 397.782 315.165 392.999L253.248 286.149C250.463 281.343 250.463 275.414 253.248 270.609L315.165 163.758C317.936 158.975 323.046 156.031 328.573 156.031H452.51C458.038 156.031 463.147 158.975 465.919 163.758L527.836 270.609Z",
    stroke: "url(#paint11_linear_1426_1482)",
    style: {},
    strokeWidth: 1.6313
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M425.379 241.243C415.484 241.243 405.589 245.009 398.057 252.542L360.542 290.057C357.895 292.703 357.895 296.995 360.542 299.642C361.865 300.966 363.6 301.628 365.335 301.628C367.07 301.628 368.804 300.966 370.128 299.642L407.642 262.127C412.533 257.237 418.956 254.793 425.379 254.793C431.802 254.793 438.225 257.237 443.116 262.127C452.895 271.908 452.896 287.821 443.117 297.601L405.601 335.116C400.711 340.005 394.287 342.451 387.864 342.451C381.441 342.451 375.017 340.005 370.128 335.116C368.804 333.792 367.07 333.13 365.335 333.13C363.6 333.13 361.865 333.792 360.542 335.116C357.895 337.762 357.895 342.053 360.542 344.701C368.075 352.233 377.97 356 387.865 356C397.76 356 407.653 352.234 415.186 344.702L452.701 307.186C467.767 292.121 467.766 267.608 452.701 252.542C445.168 245.009 435.274 241.243 425.379 241.243Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M395.135 211C385.241 211 375.346 214.766 367.813 222.3L330.299 259.814C315.234 274.879 315.234 299.393 330.3 314.459C337.832 321.991 347.726 325.758 357.621 325.758C367.515 325.758 377.41 321.991 384.943 314.459L422.457 276.943C425.105 274.297 425.105 270.006 422.457 267.358C421.134 266.035 419.399 265.373 417.665 265.373C415.931 265.373 414.196 266.035 412.872 267.358L375.358 304.873C370.468 309.763 364.045 312.209 357.621 312.209C351.198 312.209 344.774 309.763 339.884 304.873C330.105 295.093 330.104 279.179 339.883 269.399L377.399 231.885C382.288 226.995 388.712 224.55 395.135 224.55C401.559 224.55 407.982 226.994 412.872 231.885C414.196 233.208 415.931 233.87 417.665 233.87C419.399 233.87 421.134 233.208 422.457 231.885C425.105 229.238 425.105 224.947 422.457 222.3C414.925 214.766 405.03 211 395.135 211Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("defs", null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1426_1482",
    x1: -226.906,
    y1: 421.118,
    x2: 58.5713,
    y2: 667.444,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1F6FF",
    stopOpacity: 0.23,
    style: (_ref15 = {
      stopColor: "#E1F6FF"
    }, _defineProperty(_ref15, "stopColor", "color(display-p3 0.8838 0.9651 1.0000)"), _defineProperty(_ref15, "stopOpacity", 0.23), _ref15)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.07,
    style: {
      stopColor: "white",
      stopOpacity: 0.07
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1426_1482",
    x1: 6.36987,
    y1: 558.147,
    x2: 291.848,
    y2: 804.473,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.12,
    style: {
      stopColor: "white",
      stopOpacity: 0.12
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0,
    style: {
      stopColor: "none",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1426_1482",
    x1: 242.908,
    y1: 691.914,
    x2: 528.386,
    y2: 938.24,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.12,
    style: {
      stopColor: "white",
      stopOpacity: 0.12
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0,
    style: {
      stopColor: "none",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1426_1482",
    x1: 481.079,
    y1: 563.041,
    x2: 766.556,
    y2: 809.367,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.12,
    style: {
      stopColor: "white",
      stopOpacity: 0.12
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0,
    style: {
      stopColor: "none",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1426_1482",
    x1: -223.645,
    y1: 155.215,
    x2: 61.833,
    y2: 401.542,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0,
    style: {
      stopColor: "none",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.07,
    style: {
      stopColor: "white",
      stopOpacity: 0.07
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1426_1482",
    x1: 9.63257,
    y1: 21.4482,
    x2: 241.277,
    y2: 267.775,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0,
    style: {
      stopColor: "none",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.07,
    style: {
      stopColor: "white",
      stopOpacity: 0.07
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1426_1482",
    x1: 385.647,
    y1: -112.318,
    x2: 385.647,
    y2: 134.008,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0,
    style: {
      stopColor: "none",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.07,
    style: {
      stopColor: "white",
      stopOpacity: 0.07
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1426_1482",
    x1: 8.00171,
    y1: 292.245,
    x2: 293.479,
    y2: 538.571,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1F6FF",
    stopOpacity: 0.23,
    style: (_ref16 = {
      stopColor: "#E1F6FF"
    }, _defineProperty(_ref16, "stopColor", "color(display-p3 0.8838 0.9651 1.0000)"), _defineProperty(_ref16, "stopOpacity", 0.23), _ref16)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.07,
    style: {
      stopColor: "white",
      stopOpacity: 0.07
    }
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_radial_1426_1482",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(385.932 549.174) rotate(90) scale(153.27 88.0495)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2E335A",
    style: (_ref17 = {
      stopColor: "#2E335A"
    }, _defineProperty(_ref17, "stopColor", "color(display-p3 0.1804 0.2000 0.3529)"), _defineProperty(_ref17, "stopOpacity", 1), _ref17)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1C1B33",
    stopOpacity: 0.2,
    style: (_ref18 = {
      stopColor: "#1C1B33"
    }, _defineProperty(_ref18, "stopColor", "color(display-p3 0.1098 0.1059 0.2000)"), _defineProperty(_ref18, "stopOpacity", 0.2), _ref18)
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint9_angular_1426_1482",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(385.648 549.174) rotate(90) scale(123.163 142.739)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0210551,
    stopColor: "#7AD7FF",
    stopOpacity: 0.45,
    style: (_ref19 = {
      stopColor: "#7AD7FF"
    }, _defineProperty(_ref19, "stopColor", "color(display-p3 0.4779 0.8425 1.0000)"), _defineProperty(_ref19, "stopOpacity", 0.45), _ref19)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.322441,
    stopColor: "#73A3FF",
    style: (_ref20 = {
      stopColor: "#73A3FF"
    }, _defineProperty(_ref20, "stopColor", "color(display-p3 0.4514 0.6379 1.0000)"), _defineProperty(_ref20, "stopOpacity", 1), _ref20)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.495395,
    stopColor: "#66D1FF",
    stopOpacity: 0.05,
    style: (_ref21 = {
      stopColor: "#66D1FF"
    }, _defineProperty(_ref21, "stopColor", "color(display-p3 0.3984 0.8185 1.0000)"), _defineProperty(_ref21, "stopOpacity", 0.05), _ref21)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.698546,
    stopColor: "#83ADFF",
    style: (_ref22 = {
      stopColor: "#83ADFF"
    }, _defineProperty(_ref22, "stopColor", "color(display-p3 0.5138 0.6791 1.0000)"), _defineProperty(_ref22, "stopOpacity", 1), _ref22)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.953459,
    stopColor: "#5C93FF",
    style: (_ref23 = {
      stopColor: "#5C93FF"
    }, _defineProperty(_ref23, "stopColor", "color(display-p3 0.3593 0.5771 1.0000)"), _defineProperty(_ref23, "stopOpacity", 1), _ref23)
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_1426_1482",
    x1: 482.71,
    y1: 295.507,
    x2: 768.188,
    y2: 541.834,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1F6FF",
    stopOpacity: 0.23,
    style: (_ref24 = {
      stopColor: "#E1F6FF"
    }, _defineProperty(_ref24, "stopColor", "color(display-p3 0.8838 0.9651 1.0000)"), _defineProperty(_ref24, "stopOpacity", 0.23), _ref24)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.07,
    style: {
      stopColor: "white",
      stopOpacity: 0.07
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_1426_1482",
    x1: 247.803,
    y1: 155.215,
    x2: 533.281,
    y2: 401.542,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1F6FF",
    stopOpacity: 0.23,
    style: (_ref25 = {
      stopColor: "#E1F6FF"
    }, _defineProperty(_ref25, "stopColor", "color(display-p3 0.8838 0.9651 1.0000)"), _defineProperty(_ref25, "stopOpacity", 0.23), _ref25)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.07,
    style: {
      stopColor: "white",
      stopOpacity: 0.07
    }
  })), _ref26));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignupHeroFigure);
export default __webpack_public_path__ + "static/media/signup-hero-figure.ebf872eb85851d653acf80a1be621fa0.svg";
export { ForwardRef as ReactComponent };